export default function getServiceData(services, code) {
  if (!code) return;
  return services.find(service => service.code === code);
}
